import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
const Invoicepayment = () => {
  const [invoicepayment, setInvoicepayment] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`invoicepayment?page=${page}`);
      setInvoicepayment(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`invoicepayment/${id}`);
      setInvoicepayment(
        invoicepayment.filter((invoicepayment) => invoicepayment.id !== id),
      );
    }
  };

  const generatePdfReceipt = async (invoiceNo) => {
    try {
      const response = await axios.get(`receiptGen/${invoiceNo}`, {
        responseType: "blob", // 🔥 THIS IS REQUIRED
        // withCredentials: true // only if you use cookies
      });

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `receipt_${invoiceNo}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  return (
    <Wrapper pageTitle={"Invoice Payment"}>
      <InnerNav
        createLink={"/invoicepaymentCreate"}
        listLink={"/invoicepayment"}
      />
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Payment Date </th>
                <th className="px-4 py-3">Client </th>
                <th className="px-4 py-3">Invoice ID </th>
                <th className="px-4 py-3">Invoice No </th>
                <th className="px-4 py-3">Amount </th>
                <th className="px-4 py-3">Receipt No </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {invoicepayment?.map((invoicepayment) => {
                return (
                  <tr
                    key={invoicepayment.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{invoicepayment.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {invoicepayment.payment_date}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoicepayment.client.name}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoicepayment.invoice_id}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoicepayment.invoice_no}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoicepayment.amount}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoicepayment.receipt_no}
                    </td>
                    <td className="flex px-4 py-3 text-sm">
                      <span
                        onClick={() =>
                          generatePdfReceipt(invoicepayment.receipt_no)
                        }
                      >
                        {" "}
                        <BsFileEarmarkPdfFill className="text-[oklch(63.7%_0.237_25.331)] " />
                        Print PDF
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Invoicepayment;
